import { useId, useRef, useState } from "react";
import { Button, ButtonProps, Popover, PopoverBody } from "reactstrap";
import "./ButtonWithDisabledReason.css";

interface Props extends ButtonProps {
  /**
   * If set, the button looks disabled but stays tappable: instead of running
   * onClick it shows the reason in a popover. Unlike a title tooltip this also
   * works on touch devices without hover.
   */
  disabledReason?: string;
}

export function ButtonWithDisabledReason({
  disabledReason,
  onClick,
  className,
  children,
  ...buttonProps
}: Props) {
  const targetRef = useRef<HTMLButtonElement>(null);
  const reasonId = useId();
  const [reasonOpen, setReasonOpen] = useState(false);
  const blocked = disabledReason !== undefined;

  return (
    <>
      <Button
        {...buttonProps}
        innerRef={targetRef}
        className={
          blocked
            ? `${className ?? ""} disabled button-with-disabled-reason-blocked`
            : className
        }
        aria-disabled={blocked || undefined}
        aria-describedby={blocked ? reasonId : undefined}
        onClick={blocked ? undefined : onClick}
      >
        {children}
      </Button>
      {blocked && (
        <>
          <span id={reasonId} className="visually-hidden">
            {disabledReason}
          </span>
          <Popover
            target={targetRef}
            isOpen={reasonOpen}
            toggle={() => setReasonOpen((open) => !open)}
            trigger="legacy"
            placement="auto"
          >
            <PopoverBody>{disabledReason}</PopoverBody>
          </Popover>
        </>
      )}
    </>
  );
}
